import type { CloudEnvironment } from "../types/CloudEnvironment";

export function isSovereignEnvironment(cloudEnv: CloudEnvironment): boolean {
    return cloudEnv.usesGlobalDirectory === false;
}
